import { parseBoolean } from "../helpers/utils"

export const API_URL: string = import.meta.env.VITE_API_URL
export const SANDBOX: boolean = parseBoolean(import.meta.env.VITE_IS_SANDBOX);
export const STRIPE_PUBLICABLE_KEY: string = SANDBOX ? import.meta.env.VITE_STRIPE_PUBLICABLE_KEY_SANDBOX : import.meta.env.VITE_STRIPE_PUBLICABLE_KEY_PROD;
export const MINIMO_PARA_SPEI: number = 700;